import styled from 'styled-components';

import Raw from 'shared/components/presentational/Raw/Raw';
import BaseWrapper from 'shared/components/presentational/Wrapper/Wrapper';
import { FONT_FAMILIES, FONT_WEIGHTS } from 'shared/constants/theme';

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-l);
  margin: var(--spacing-l) var(--spacing-m);
`;

export const Wrapper = styled(BaseWrapper)`
  padding: 0 var(--container-minimum-padding);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
  --title-position: left;
`;

export const HeadContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
`;

export const Subtitle = styled(Raw)`
  font-size: var(--text-size-base);
  color: var(--text-title);
  p {
    margin-bottom: 0;
  }
`;

export const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid var(--surface-border-default);
  border-radius: var(--border-radius-xxs);
`;

export const OptionsList = styled.ul`
  list-style: none;
  padding: var(--spacing-s);
`;

export const Option = styled.li`
  font-family: ${FONT_FAMILIES.brand};
  font-weight: ${FONT_WEIGHTS.bold};
  padding: var(--spacing-xs) 0;
`;

export const Total = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--secondary-default);
  border-top: 1px solid var(--surface-border-default);
  padding: var(--spacing-m) var(--spacing-s);
`;

export const TotalLabel = styled.p`
  font-size: var(--text-size-base);
  margin: 0;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-s);
`;
